export const FIREBASE_ERRORS = {
  AUTH_REQUIRES_RECENT_LOGIN: 'auth/requires-recent-login',
  AUTH_USER_DISABLED: 'auth/user-disabled',
  AUTH_INVALID_EMAIL: 'auth/invalid-email',
  AUTH_INVALID_CREDENTIAL: 'auth/invalid-credential',
  AUTH_USER_NOT_FOUND: 'auth/user-not-found',
  AUTH_WRONG_PASSWORD: 'auth/wrong-password',
  DB_USER_NOT_FOUND: '404: User not found',
};

export const GET_NOTE_ERRORS = {
  NOTE_NOT_FOUND: 'Note not found',
  NOTE_DOES_NOT_BELONG_TO_USER: 'Note does not belong to user',
  INVITATION_EXPIRED: 'Invitation has expired or access is not granted',
};

export const FIREBASE_STORAGE_ERRORS = {
  UNAUTHORIZED: 'storage/unauthorized',
  UNAUTHENTICATED: 'storage/unauthenticated',
  OBJECT_NOT_FOUND: 'storage/object-not-found',
};

const MAX_ERROR_MESSAGE_LENGTH = 150;

/**
 * Truncates an error message to a reasonable length for display in alerts.
 * Adds ellipsis if truncated.
 */
export const truncateErrorMessage = (
  message: string | null | undefined,
  maxLength: number = MAX_ERROR_MESSAGE_LENGTH,
): string => {
  if (!message) return '';
  if (message.length <= maxLength) return message;
  return message.slice(0, maxLength - 3) + '...';
};
